<div class="title">
  <span>{{ titleKey | i18next }}</span>
      <i id="close-btn-preview-request-dialog" class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
  <ng-container *ngIf="loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>

  <div class="error" *ngIf="!loading && errorKey">{{ errorKey | i18next }}</div>

  <!-- Social -->
  <table class="full-width-table" *ngIf="!loading && isSocial">
    <tbody>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_to' | i18next }}</td>
        <td>{{ socialTo }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_from' | i18next }}</td>
        <td>{{ socialFrom }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_message' | i18next }}</td>
        <td>{{ socialMessage }}</td>
      </tr>
    </tbody>
  </table>

  <!-- Email -->
  <table class="full-width-table" *ngIf="!loading && isEmail">
    <tbody>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_to' | i18next }}</td>
        <td>{{ emailTo }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_from' | i18next }}</td>
        <td>{{ emailFrom }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_receivedtime' | i18next }}</td>
        <td>{{ emailReceivedTime }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_subject' | i18next }}</td>
        <td>{{ emailSubject }}</td>
      </tr>
      <tr class="mat-mdc-row" *ngIf="emailLink">
        <td class="bold">{{ 'realtime:queuedetails_lang_link' | i18next }}</td>
        <td><a [href]="emailLink" target="_blank" rel="noopener">{{ emailLink }}</a></td>
      </tr>
    </tbody>
  </table>

  <!-- Scheduled task -->
  <table class="full-width-table" *ngIf="!loading && isTask">
    <tbody>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_createdby' | i18next }}</td>
        <td>{{ createdBy }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_contactname' | i18next }}</td>
        <td>{{ contactName }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:usergroups_details_phone_number' | i18next }}</td>
        <td>{{ phone }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_contactid' | i18next }}</td>
        <td>{{ contactId }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:ongoingcalls_duration' | i18next }}</td>
        <td>{{ duration }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'ticker:queues_queue' | i18next }}</td>
        <td>{{ queueKey }}</td>
      </tr>
      <tr class="mat-mdc-row">
        <td class="bold">{{ 'realtime:queuedetails_lang_subject' | i18next }}</td>
        <td>{{ taskSubject }}</td>
      </tr>
      <tr class="mat-mdc-row" *ngIf="taskLink">
        <td class="bold">{{ 'realtime:queuedetails_lang_link' | i18next }}</td>
        <td><a [href]="taskLink" target="_blank" rel="noopener">{{ taskLink }}</a></td>
      </tr>
    </tbody>
  </table>

  <!-- Transfer info (uses entryTimeString from API) -->
  <div *ngIf="!loading && transferInfo?.length">
    <div class="section-title bold">{{ 'realtime:queuedetails_lang_transferinfo' | i18next }}</div>
    <table class="full-width-table">
      <tbody>
        <ng-container *ngFor="let t of transferInfo">
          <tr class="mat-mdc-row">
            <td colspan="2">{{ t.name }} {{ t.entryTimeString }}</td>
          </tr>
          <tr class="mat-mdc-row">
            <td colspan="2">{{ t.message }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

